export default __webpack_public_path__ + "70e1546cb31f915982f5ca933e111a0d.svg";